import React from 'react';
import { AlertTriangle, Search, UserRound } from 'lucide-react';
import { Input } from '@/components/ui/input';

const FILTERS = [
  ['all', 'All risk'],
  ['critical', 'Critical'],
  ['high', 'High'],
  ['medium', 'Medium'],
  ['low', 'Low'],
];

export const ReviewFilters = ({ filters, setFilters, editors, metrics }) => (
  <aside className="space-y-5 border border-border bg-panel-header/20 p-4" data-testid="review-filter-rail">
    <section className="grid grid-cols-2 gap-2" data-testid="review-inbox-metrics">
      {[
        ['open', 'Open', metrics.open],
        ['critical', 'Critical', metrics.critical],
        ['unassigned', 'Unassigned', metrics.unassigned],
        ['ai-pending', 'AI pending', metrics.ai_pending],
      ].map(([key, label, value]) => (
        <div key={key} className="border border-border bg-card px-3 py-2" data-testid={`review-metric-${key}`}>
          <div className="font-mono-stat text-lg font-semibold tabular-nums">{value || 0}</div>
          <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</div>
        </div>
      ))}
    </section>

    <section className="space-y-2">
      <label className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground" htmlFor="review-queue-search">Search</label>
      <div className="relative">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
        <Input
          id="review-queue-search"
          value={filters.search}
          onChange={(event) => setFilters({ ...filters, search: event.target.value })}
          placeholder="Title or author"
          className="h-9 pl-8 text-xs"
          data-testid="review-queue-search"
        />
      </div>
    </section>

    <section className="space-y-2">
      <div className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
        <AlertTriangle className="h-3.5 w-3.5" /> Risk
      </div>
      <div className="grid grid-cols-2 gap-1.5">
        {FILTERS.map(([value, label]) => (
          <button
            key={value}
            type="button"
            onClick={() => setFilters({ ...filters, risk: value })}
            className={`border px-2 py-1.5 text-left text-[11px] font-medium transition-colors ${filters.risk === value ? 'border-primary bg-primary text-primary-foreground' : 'border-border bg-card hover:bg-secondary'}`}
            data-testid={`risk-filter-${value}`}
          >
            {label}
          </button>
        ))}
      </div>
    </section>

    <section className="space-y-2">
      <label className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground" htmlFor="review-status-filter">
        Status
      </label>
      <select
        id="review-status-filter"
        value={filters.status}
        onChange={(event) => setFilters({ ...filters, status: event.target.value })}
        className="h-9 w-full border border-border bg-card px-2 text-xs outline-none focus:ring-2 focus:ring-ring"
        data-testid="review-status-filter"
      >
        <option value="all">All statuses</option>
        <option value="pending">Pending</option>
        <option value="in_review">In review</option>
        <option value="reviewed">Reviewed</option>
        <option value="changes_requested">Changes requested</option>
        <option value="resolved">Resolved</option>
      </select>
    </section>

    <section className="space-y-2">
      <label className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground" htmlFor="review-assignee-filter">
        <UserRound className="h-3.5 w-3.5" /> Assignee
      </label>
      <select
        id="review-assignee-filter"
        value={filters.assignee}
        onChange={(event) => setFilters({ ...filters, assignee: event.target.value })}
        className="h-9 w-full border border-border bg-card px-2 text-xs outline-none focus:ring-2 focus:ring-ring"
        data-testid="review-assignee-filter"
      >
        <option value="all">Everyone</option>
        <option value="unassigned">Unassigned</option>
        {editors.map((editor) => <option key={editor} value={editor}>{editor}</option>)}
      </select>
    </section>
  </aside>
);